"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaInputField = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var formik_1 = require("formik");
var get_1 = __importDefault(require("lodash/get"));
var react_1 = __importDefault(require("react"));
// eslint-disable-next-line import/no-cycle
var nested_schemas_1 = require("./components/nested-schemas");
var control_1 = require("./control");
function SchemaInputField(_a) {
    var schema = _a.schema, propertyKey = _a.propertyKey, hideEmptyLabel = _a.hideEmptyLabel, preventFullWidth = _a.preventFullWidth, name = _a.name, currentPath = _a.currentPath;
    var errors = (0, formik_1.useFormikContext)().errors;
    var field = (schema.properties || {})[propertyKey];
    // When there is no type it means it is a hidden field.
    if (!field || !field.inputType) {
        return null;
    }
    var inputMetadata = field.inputMetadata;
    // nested field path
    var fieldPath = "" + (currentPath || '') + propertyKey;
    // field path key with form name
    var fullPathKey = name + "." + fieldPath;
    // recursion, if field is a nested-schema, render schema-input back
    if (nested_schemas_1.NESTED_SCHEMA_TYPES.includes(field.inputType)) {
        return (react_1.default.createElement("div", { style: { width: '100%' } },
            react_1.default.createElement(nested_schemas_1.NestedSchemaField, { key: propertyKey, name: name, schema: field, fieldPath: fieldPath })));
    }
    var error = getFieldError(errors, fullPathKey);
    return (react_1.default.createElement(core_ui_1.Field, { fieldId: propertyKey, label: inputMetadata === null || inputMetadata === void 0 ? void 0 : inputMetadata.label, subText: inputMetadata === null || inputMetadata === void 0 ? void 0 : inputMetadata.subText, error: getFieldError(errors, fullPathKey), hideEmptyLabel: hideEmptyLabel, style: preventFullWidth ? {} : { width: '100%' } },
        react_1.default.createElement(control_1.SchemaInputControl, { name: name, type: field.inputType, schema: field, metadata: inputMetadata, fieldPath: fieldPath }),
        !error && react_1.default.createElement("div", { style: { height: 18 } })));
}
exports.SchemaInputField = SchemaInputField;
function getFieldError(errors, propertyKey) {
    var error = (0, get_1.default)(errors, propertyKey);
    // if it's a nested schema, error sometimes will be an object of errors from the nested schema
    // so we just ignore it
    if (typeof error !== 'string') {
        return undefined;
    }
    return error;
}
